export const lengthMinimum = /^.{8,}$/;
export const atLeatOneLowercaseAndOneUppercase = /.*([a-z].*[A-Z])|([A-Z].*[a-z]).*/;
export const atLeastOneNumber = /.*[0-9].*/;
export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const zipCodeRegex = /^[a-zA-Z0-9]*[\s-]?[a-zA-Z0-9]*$/;
export const usZipCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const amountRegex = /^\d*\.?\d*$/;
export const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
export const positiveNumber = /^(\s*|\d*[1-9]\d*)$/;
